import { z } from "zod";
// =============================================================================
// Request shapes for the photo → post flow (spec §6 flow 2, phase 8).
//
// The uploaded bytes are not described here — they arrive as multipart and are
// checked against imageTypes.ts. These schemas cover the fields that travel
// alongside them.
// =============================================================================
/**
 * What the owner says the photo IS.
 *
 * Required, and required for a reason: the enhancement prompt tells the model
 * to keep "the product itself" unchanged, and without a subject it has nothing
 * to anchor that instruction to. "A photo" produces a model free to decide
 * what matters in the frame.
 */
export const photoSubjectSchema = z
    .string()
    .trim()
    .min(3, "Say what the photo shows, e.g. 'blue running shoes'")
    .max(200);
export const uploadPhotoSchema = z.object({
    brandId: z.string().uuid(),
    subject: photoSubjectSchema,
    /**
     * Run the enhancement. Default true because it is the feature, but the owner
     * can keep their own photo — a studio shot does not need our help, and for
     * some products (food they cooked, a hand-made item) the original is the
     * honest one.
     */
    enhance: z
        .union([z.boolean(), z.literal("true"), z.literal("false")])
        .default(true)
        .transform((v) => v === true || v === "true"),
});
export const enhanceAssetSchema = z.object({
    subject: photoSubjectSchema,
});
/** Turning an existing asset into a draft post with captions per page. */
export const postFromAssetSchema = z.object({
    /** Defaults to the subject the asset was uploaded with. */
    topic: z.string().trim().min(3).max(500).optional(),
    socialAccountIds: z.array(z.string().uuid()).max(20).optional(),
    facts: z.array(z.string().max(300)).max(20).optional(),
});
export const listAssetsSchema = z.object({
    brandId: z.string().uuid(),
    limit: z.coerce.number().int().min(1).max(100).default(24),
});
//# sourceMappingURL=schema.js.map